import styled, { StyledComponent } from "styled-components";

export interface ISelectToggleButtonStyledProps extends React.ComponentProps<StyledComponent<"div", any, {}, never>> {
    isOpen?: boolean;
}

export const SelectToggleButtonStyled = styled.div<ISelectToggleButtonStyledProps>`
    padding: 16px 40px 16px 16px;
    border-radius: 16px;
    background: var(--color-background-reduced);
    position: relative;
    cursor: pointer;
    width: 100%;
    color: var(--color-label-primary);
    font-weight: 400;
    display: flex;
    align-items: center;

    ${({ isOpen }) => isOpen && 'border-color: var(--color-main);'}
    ${({ isOpen }) => isOpen && 'color: var(--color-white);'}

    &:hover {
        color: var(--color-label-primary);
        border: var(--color-label-tertiary);
        
        .right-icon svg {
            fill: var(--color-label-secondary);
        }
    }
  
    &.sm {
        padding: 8px 40px 8px 16px;
        .right-icon {
          right: 8px;
        }
    }
`;


export interface ISelectToggleButtonStyledRightIconStyledProps extends React.ComponentProps<StyledComponent<"div", any, {}, never>> {
    isOpen?: boolean;
}

export const SelectToggleButtonStyledRightIconStyled = styled.div<ISelectToggleButtonStyledRightIconStyledProps>`
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translate(0, -50%);

    svg {
        fill: var(--color-label-secondary);
        ${({ isOpen }) => isOpen && 'transform: rotate(180deg);'}
        transition: transform 200ms ease, fill 200ms ease;
    }
`;